import { Notification } from 'element-ui'
import {NotificationGlobalConfig} from '../../../../../config/Notification_config.js'
export const Obvestilo = {
  methods: {
    ShowSuccessMessage (prenosniParam) {
      let duration = this.ShowMessageGetDuration(prenosniParam)
      Notification({
        title: 'Uspešno',
        message: prenosniParam.message,
        type: NotificationGlobalConfig.TYPE_SUCCESS,
        position: NotificationGlobalConfig.POSITION,
        duration: duration,
        offset: NotificationGlobalConfig.OFFSET
      })
    },
    ShowWarningMessage (prenosniParam) {
      let duration = this.ShowMessageGetDuration(prenosniParam)
      Notification({
        title: 'Opozorilo',
        message: prenosniParam.message,
        type: NotificationGlobalConfig.TYPE_WARNING,
        position: NotificationGlobalConfig.POSITION,
        duration: duration
      })
    },
    ShowErrorMessage (prenosniParam) {
      let duration = this.ShowMessageGetDuration(prenosniParam)
      Notification({
        title: 'Napaka',
        message: prenosniParam.message,
        type: NotificationGlobalConfig.TYPE_ERROR,
        position: NotificationGlobalConfig.POSITION,
        duration: duration
      })
    },
    ShowMessageGetDuration (prenosniParam) {
      let duration = NotificationGlobalConfig.DURATION
      if (prenosniParam.duration !== undefined) {
        duration = prenosniParam.duration
      }
      return duration
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/Notification.js